import StyleButton from './StyleButton'
export default StyleButton



/** WEBPACK FOOTER **
 ** ./src/Editors/StyleButton/index.js
 **/